<template>
	<div class="wrap" @click="removelogin()">
		<header class="header">
			<img src="../../static/images/banner_bg.jpg" alt="">
			<navHeader ref=navHeader></navHeader>
			<div class="dbox">
				<h2>
					{{langtrans().ddjxyp[languageIndex]}}
				</h2>
				<p>{{langtrans().yyqbjq[languageIndex]}}</p>
			</div>
			<div class="points_box" :class="{points_box1:languageIndex}">
				<ul>
					<li>
						<div class="points_list_box">
							<p>{{langtrans().fggqqj[languageIndex]}}</p>
							<p>{{langtrans().jyjgbp[languageIndex]}}</p>
						</div>
					</li>
					<li>
						<div class="points_list_box">
							<p>{{langtrans().cczzzg[languageIndex]}}</p>
							<p>{{langtrans().bzhhlc[languageIndex]}}</p>
						</div>
					</li>
					<li>
						<div class="points_list_box">
							<p>{{langtrans().qcjylc[languageIndex]}}</p>
							<p>{{langtrans().jyggcq[languageIndex]}}</p>
						</div>
					</li>
					<li>
						<div class="points_list_box">
							<p>{{langtrans().fyggqx[languageIndex]}}</p>
							<p>{{langtrans().jgjycb[languageIndex]}}</p>
						</div>
					</li>
				</ul>
			</div>
		</header>
		<section class="section">
			<div class="top_innovation">
				<div class="tit_top_box">
					<h2>
						<img src="../../static/images/line_bg.png" alt="">
						{{langtrans().pttccx[languageIndex]}}
						<img src="../../static/images/line_bg_01.png" alt="">
					</h2>
				</div>
				<p class="tit_box">
					<span>{{langtrans().qqggdd[languageIndex]}}</span>
				</p>
				<div class="innovation_details">
					<ul>
						<li class="pointer_box">
							<img src="../../static/images/icon_01.png" alt="">
							<h3>{{langtrans().pttjy[languageIndex]}}</h3>
							<p>{{langtrans().pttyhq[languageIndex]}}</p>
						</li>
						<li class="pointer_box">
							<img src="../../static/images/icon_02.png" alt="">
							<h3>{{langtrans().ddddxd[languageIndex]}}<br />&nbsp;</h3>
							<p>{{langtrans().pttgwd[languageIndex]}}</p>
						</li>
						<li class="pointer_box">
							<img src="../../static/images/icon_03.png" alt="">
							<h3>{{langtrans().ddddjs[languageIndex]}}</h3>
							<p>{{langtrans().dddddd[languageIndex]}}</p>
						</li>
						<li class="pointer_box">
							<img src="../../static/images/icon_04.png" alt="">
							<h3>{{langtrans().pttba[languageIndex]}} </h3>
							<p>{{langtrans().gwclll[languageIndex]}}</p>
						</li>
						<li class="pointer_box">
							<img src="../../static/images/icon_05.png" alt="">
							<h3>{{langtrans().fyffw[languageIndex]}}</h3>
							<p>{{langtrans().ddddyy[languageIndex]}}</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="middle_box">
				<div class="tit_middle_box">
					<h2>
						<img src="../../static/images/line_bg.png" alt="">
						{{langtrans().wddjyc[languageIndex]}}
						<img src="../../static/images/line_bg_01.png" alt="">
					</h2>
				</div>
				<div class="middle_details">
					<ul>
						<li class="pointer_box" @mouseenter="dataDetails($event)" @mouseleave="hiddenDetail($event)">
							<div class="title_box">
								{{langtrans().yljy[languageIndex]}}
							</div>
							<div class="txt_box">
								<p>
									{{langtrans().ccmzzy[languageIndex]}}
								</p>
							</div>
							<h3>Medical Assistance</h3>
							<div class="img_box">
								<img src="../../static/images/icon_08.png" alt="">
							</div>
							<p>{{langtrans().yljy[languageIndex]}}</p>
						</li>
						<li class="pointer_box" @mouseenter="dataDetails($event)" @mouseleave="hiddenDetail($event)">
							<div class="title_box">
								{{langtrans().zhjy[languageIndex]}}
							</div>
							<div class="txt_box">
								<p>
									{{langtrans().ffsznn[languageIndex]}}
								</p>
							</div>
							<h3>Natural Disaster Assistance</h3>
							<div class="img_box">
								<img src="../../static/images/icon_09.png" alt="">
							</div>
							<p>{{langtrans().zhjy[languageIndex]}}</p>
						</li>
						<li class="pointer_box" @mouseenter="dataDetails($event)" @mouseleave="hiddenDetail($event)">
							<div class="title_box">
								{{langtrans().zajy[languageIndex]}}
							</div>
							<div class="txt_box">
								<p>
									{{langtrans().shkzaj[languageIndex]}}
								</p>
							</div>
							<h3>Public Security Assistance</h3>
							<div class="img_box">
								<img src="../../static/images/icon_10.png" alt="">
							</div>
							<p>{{langtrans().zajy[languageIndex]}}</p>
						</li>
						<li class="pointer_box" @mouseenter="dataDetails($event)" @mouseleave="hiddenDetail($event)">
							<div class="title_box">
								{{langtrans().dljy[languageIndex]}}
							</div>
							<div class="txt_box">
								<p>
									{{langtrans().dlpmdl[languageIndex]}}
								</p>
							</div>
							<h3>Roadside Assistance</h3>
							<div class="img_box">
								<img src="../../static/images/icon_06.png" alt="">
							</div>
							<p>{{langtrans().dljy[languageIndex]}}</p>
						</li>
						<li class="pointer_box" @mouseenter="dataDetails($event)" @mouseleave="hiddenDetail($event)">
							<div class="title_box">
								{{langtrans().lxhhxh[languageIndex]}}
							</div>
							<div class="txt_box">
								<p>
									{{langtrans().lxhhxh[languageIndex]}}
								</p>
							</div>
							<h3>Travel Assistance</h3>
							<div class="img_box">
								<img src="../../static/images/icon_07.png" alt="">
							</div>
							<p>{{langtrans().lxhhxh[languageIndex]}}</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="bottom_box">
				<div class="tit_bottom_box">
					<h2>
						<img src="../../static/images/line_bg.png" alt="">
						{{langtrans().bbfttx[languageIndex]}}
						<img src="../../static/images/line_bg_01.png" alt="">
					</h2>
				</div>
				<div class="bottom_scheme">
					<img src="../../static/images/arrow_left.png" alt="">
					<ul class="scheme_list">
						<li @click="insurer()" class="pointer_box">
							<img src="../../static/images/insurance_commpany.png" alt="">
							<div>
								<h3>{{langtrans().bxgs[languageIndex]}}</h3>
								<div class="scheme_tit_box">
									{{langtrans().wwbxgs[languageIndex]}}
								</div>
								<span>{{langtrans().ddjczk[languageIndex]}}</span>
							</div>
						</li>
						<li @click="TravelAgency()" class="pointer_box">
							<img src="../../static/images/travel_agency.png" alt="">
							<div>
								<h3>{{langtrans().lxhhxh[languageIndex]}}</h3>
								<div class="scheme_tit_box">
									{{langtrans().wwlxhh[languageIndex]}}
								</div>
								<span>{{langtrans().ddjczk[languageIndex]}}</span>
							</div>
						</li>
						<li @click="Scenicspot()" class="pointer_box">
							<img src="../../static/images/scenic_spots.png" alt="">
							<div>
								<h3>{{langtrans().jyqojy[languageIndex]}}</h3>
								<div class="scheme_tit_box">
									{{langtrans().wwjydd[languageIndex]}}
								</div>
								<span>{{langtrans().ddjczk[languageIndex]}}</span>
							</div>
						</li>
						<li @click="overseas()" class="pointer_box">
							<img src="../../static/images/foreign_enterprises.png" alt="">
							<div>
								<h3>{{langtrans().zwqqy[languageIndex]}}</h3>
								<div class="scheme_tit_box">
									{{langtrans().wwzwqq[languageIndex]}}
								</div>
								<span>{{langtrans().ddjczk[languageIndex]}}</span>
							</div>
						</li>
					</ul>
					<img src="../../static/images/arrow.png" alt="">
				</div>
			</div>
		</section>
		<vFooter @performHeader=performHeader></vFooter>
	</div>
</template>

<script>
	import langtrans from "@/assets/languagejs/Index.vue.trans.js";
	import {
		Message
	} from "element-ui";
	import Lodding from "./lodding.vue";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from "promise-polyfill";
	import navHeader from '@/components/header/indexHeader'
	import vFooter from '@/components/footer/indexFooter'

	if (!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		components: {
			Lodding,
			navHeader,
			vFooter
		},
		data() {
			return {
				loddingflag: true,
				routerobj: {},
				flag: true,
				usertype: "",
				user: "",
				pwd: "",
				loginflag: false,
				Errercontent: "", //提示框显示的字符串
				Errerflag: false, //决定提示框是否显示的flag
				time: new Date() * 1 //时间，用来监听
			};
		},
		methods: {
			langtrans() {
				return langtrans
			},
			dataDetails(e) {
				let txtbox = e.target.querySelector(".txt_box");
				let titlebox = e.target.querySelector(".title_box");
				txtbox.style.height = "0vw";
				titlebox.style.height = "0vw";
			},
			hiddenDetail(e) {
				let txtbox = e.target.querySelector(".txt_box");
				let titlebox = e.target.querySelector(".title_box");
				txtbox.style.height = "8.4vw";
				titlebox.style.height = "5.73vw";
			},
			overseas() {
				this.$router.push({
					name: "overseas"
				});
			},
			Scenicspot() {
				this.$router.push({
					name: "Scenicspot"
				});
			},
			TravelAgency() {
				this.$router.push({
					name: "TravelAgency"
				});
			},
			insurer() {
				this.$router.push({
					name: "insurer"
				});
			},
			feedback() {
				this.$router.push({
					name: "feedback"
				});
			},
			aboutus() {
				this.$router.push({
					name: "aboutus"
				});
			},
			removelogin() {
				let login_box = document.querySelector(".login_box");
				if (login_box && this.loginflag) {
					login_box.style.display = "none";
				}
			},
			listlogin() {
				let login_list = document.querySelector(".login");
				if (this.flag) {
					login_list.style.display = "block";
					this.flag = false;
				} else {
					login_list.style.display = "none";
					this.flag = true;
				}
			},
			login(v) {
				let login_box = document.querySelector(".login_box");
				let login_list = document.querySelector(".login");
				login_list.style.display = "none";
				login_box.style.display = "block";
				this.usertype = v;
			},
			tobtn(v) {
				let that = this;
				if (v === "cancel") {
					let login_box = document.querySelector(".login_box");
					login_box.style.display = "none";
				} else {
					// 先匹配密码正则
					// if (!this.pwd.match(/^[a-zA-Z]\w{5,17}$/)) {
					//   Message.error(
					//     "密码请以字母开头，长度在6~18之间，只能包含字母、数字和下划线"
					//   );
					// }
					// 请求 判断角色
					// 0 救援机构 fac
					// 1 指挥中心
					// 2 监管机构
					fetch(constants.domain + "rescue/user/login", {
							method: "POST",
							body: `username=${this.user}&pwd=${this.pwd}`,
							mode: "cors",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						})
						.then(function(res) {
							return res.json();
						})
						.then(function(data) {
							if (data.code === 0) {
								if (Number(data.obj.user.type) == Number(that.usertype)) {
									if (that.usertype == 0) {
										Message({
											message: "救援机构登录成功",
											type: "success"
										});
										window.localStorage.setItem(
											"data",
											JSON.stringify({
												data: data.obj.token
											})
										);

										window.localStorage.setItem(
											"usertype",
											JSON.stringify({
												data: data.obj.user.type
											})
										);

										window.localStorage.setItem(
											"insti",
											JSON.stringify(data.obj.user.insti)
										);
										that.$router.push({
											name: "FacIndex",
											params: {
												token: data.obj.token,
												insti: data.obj.user.insti
											}
										});
									} else if (that.usertype === 2) {
										Message({
											message: "监管机构登录成功",
											type: "success"
										});
										window.localStorage.setItem(
											"data",
											JSON.stringify({
												data: data.obj.token
											})
										);
										window.localStorage.setItem(
											"usertype",
											JSON.stringify({
												data: data.obj.user.type
											})
										);
										window.localStorage.setItem(
											"insti",
											JSON.stringify(data.obj.user.insti)
										);
										that.$router.push({
											name: "RegIndex",
											params: {
												token: data.obj.token,
												insti: data.obj.user.insti
											}
										});
									} else if (that.usertype === 1) {
										Message({
											message: "指挥中心登录成功",
											type: "success"
										});
										window.localStorage.setItem(
											"data",
											JSON.stringify({
												data: data.obj.token
											})
										);
										window.localStorage.setItem(
											"usertype",
											JSON.stringify({
												data: data.obj.user.type
											})
										);
										window.localStorage.setItem(
											"insti",
											JSON.stringify(data.obj.user)
										);
										that.$router.push({
											name: "ComIndex",
											params: {
												token: data.obj.token,
												insti: data.obj.user
											}
										});
									}
								} else {
									if (that.usertype == 0 && data.obj.user.type != 0) {
										Message.error("登录失败，该用户不属于救援机构");
									} else if (that.usertype == 1 && data.obj.user.type != 1) {
										Message.error("登录失败，该用户不属于指挥中心");
									} else if (that.usertype == 2 && data.obj.user.type != 2) {
										Message.error("登录失败，该用户不属于监管机构");
									}
								}
							} else if (data.code === 200026) {
								//   alert("登录失败,用户名或密码错误");
								Message.error("登录失败，用户名或密码错误");
							} else {
								Message.error("登录失败，未知错误");
								//   alert("登录失败,其他错误");
							}
						});
				}
			},
			performHeader(str) {
				this.$refs.navHeader.login(str)
			}
		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
			this.loddingflag = false;
		}
	};
</script>
<style scoped="scoped">
	@import "../css/index.css";

	.header {
		position: relative;
	}

	.header img {
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue